export default __webpack_public_path__ + "static/bugswork-logo-5f1d82ec3031dc74076ad5b6333fd465.svg";